// PowerSync database singleton.
//
// Module-level singleton so all hooks and write operations share a
// single SQLite connection and sync stream. Do NOT call db.connect()
// here — the provider drives the connect/disconnect lifecycle so it
// tears down cleanly on unmount in tests. See provider.tsx.
//
// Flags:
//   enableMultiTabs: feature-detected from SharedWorker availability.
//                             Multi-tab coordination requires
//                             SharedWorker. Android Chrome shipped
//                             SharedWorker for the first time in
//                             Chrome 148 beta (April 2026); stable
//                             builds at 2026-05-08 go-live still lack
//                             it. With the flag hardcoded to `true`,
//                             the SDK never completes bootstrap on
//                             those devices: `db.connect()` hangs,
//                             `fetchCredentials()` is never called,
//                             `useAllSyncStreamsHaveSynced` stays
//                             false, and `/capture` shows a spinner
//                             that never resolves. Same class of
//                             limitation applies to older iOS Safari.
//                             Feature-detecting matches PowerSync's
//                             documented recommended pattern: desktop
//                             Chrome/Firefox, iOS Safari, Firefox
//                             Android, and Android Chrome 148+ keep
//                             multi-tab coordination; older Android
//                             Chrome gracefully degrades to a per-tab
//                             DB. Acceptable on mobile — field staff
//                             use a single tab at a time.
//   useWebWorker: true     — keeps SQLite operations off the main
//                             thread so the capture UI stays responsive.

import { PowerSyncDatabase } from '@powersync/web'

import { AppSchema } from './schema'

const supportsSharedWorker = typeof SharedWorker !== 'undefined'

export const db = new PowerSyncDatabase({
  schema: AppSchema,
  database: { dbFilename: 'citycare.db' },
  flags: {
    enableMultiTabs: supportsSharedWorker,
    useWebWorker: true,
  },
})
